import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import InsightsPage from "@/pages/Insights";

export const Route = createFileRoute("/$lang/analyses/")({
  head: ({ params }) => pageHead(params.lang, "insights"),
  component: InsightsPage,
});
